import MoreIntegrations from './MoreIntegrations'

export default MoreIntegrations
